import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import DownloadIcon from '@mui/icons-material/Download';
import Moment from 'moment';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_StockAdjustmentDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const fromSearch = location.state?.fromSearch || {};
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [data, setData] = useState(null);
    const [itemRows, setItemRows] = useState([]);
    const [itemColumns, setItemColumns] = useState([]);
    const [lotRows, setLotRows] = useState([]);
    const [lotColumns, setLotColumns] = useState([]);
    const [fileRows, setFileRows] = useState([]);
    const [fileColumns, setFileColumns] = useState([]);

    useEffect(() => {
        // 권한 설정은 주석 처리된 상태
        if(params.stock_adjustment_id === null || typeof params.stock_adjustment_id === 'undefined'){
            navigate("/m/stock_adjustment", { state: { fromSearch } });
        }

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
        }, 800);
    }, []);
    
    useEffect(() => {
        setItemColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'stock_adjustment_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
            { field: 'stock_adjustment_item_spec', headerName: '규격', width: 230, headerAlign: 'center', align:'left' },
            { field: 'stock_adjustment_item_b_stock', headerName: '변경 전 재고', type: 'number', width: 130, headerAlign: 'center', align:'right' },
            { field: 'stock_adjustment_item_a_stock', headerName: '변경 후 재고', type: 'number', width: 130, headerAlign: 'center', align:'right', editable: true },
            { field: 'stock_adjustment_item_reason', headerName: '조정 사유', width: 260, headerAlign: 'center', align:'left', editable: true }
        ]);

        setLotColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'lot_no', headerName: 'LotNo', width: 140, headerAlign: 'center', align:'center' },
            { field: 'lot_stock_adjustment_item_lot_type_name', headerName: '구분', width: 70, headerAlign: 'center', align:'center' },
            { field: 'lot_stock_adjustment_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
            { field: 'lot_stock_adjustment_item_spec', headerName: '규격', width: 175, headerAlign: 'center', align:'left' },
            { field: 'lot_stock_adjustment_save_workplace_name', headerName: '사업장',width: 115, headerAlign: 'center'},
            { field: 'lot_stock_adjustment_save_warehouse_name', headerName: '창고', width: 115, headerAlign: 'center', align:'left' },
            { field: 'lot_stock_adjustment_save_section_name', headerName: '구역',width: 115, headerAlign: 'center', align:'left'}
        ]);

        setFileColumns([
            {
                field: 'download',
                headerName: '다운로드',
                width: 100,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
            { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
            { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
            { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
            { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
            { field: 'file_type_name', headerName: '유형', width: 120, headerAlign: 'center', align:'center' },
            { field: 'file_size_dp', headerName: '크기', width: 120, headerAlign: 'center', align:'right' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
        
        if(String(MenuID) !== String(0) && typeof fromSearch.originRows === 'undefined'){
            handleSearch();
        }else{
            setOriginRows(fromSearch.originRows);
        }
    }, [MenuID]);

    useEffect(() => {
        if(typeof originRows !== 'undefined'){
            if(originRows.length > 0){
                setData(
                    {
                        stock_adjustment_id: Number(originRows[0].stock_adjustment_id),
                        stock_adjustment_number: originRows[0].stock_adjustment_number,
                        stock_adjustment_type: Number(originRows[0].stock_adjustment_type),
                        stock_adjustment_type_name: originRows[0].stock_adjustment_type_name,
                        stock_adjustment_date: originRows[0].stock_adjustment_date,
                        stock_adjustment_approval_user_id: Number(originRows[0].stock_adjustment_approval_user_id),
                        stock_adjustment_approval_user_name: originRows[0].stock_adjustment_approval_user_name,
                        stock_adjustment_reason: originRows[0].stock_adjustment_reason
                    }
                )

                var itemData = originRows.filter((item, index) => {
                    return (
                        originRows.findIndex((item2, index2) => {
                            return typeof item.stock_adjustment_item_seq !== 'undefined' && item.stock_adjustment_item_seq === item2.stock_adjustment_item_seq;
                        }) === index
                    );
                });

                // List정렬
                itemData = itemData.sort(function(a, b) { 
                    return a.stock_adjustment_item_seq < b.stock_adjustment_item_seq ? -1 : a.stock_adjustment_item_seq > b.stock_adjustment_item_seq ? 1 : 0;
                });

                setItemRows(itemData.map((item, index) => ({
                    id: item.stock_adjustment_item_seq,
                    stock_adjustment_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.stock_adjustment_item_spec, item.stock_adjustment_item_width, item.stock_adjustment_item_depth, item.stock_adjustment_item_height),
                    stock_adjustment_item_name: item.stock_adjustment_item_name,
                    stock_adjustment_item_a_stock: item.stock_adjustment_item_a_stock,
                    stock_adjustment_item_b_stock: item.stock_adjustment_item_b_stock,
                    stock_adjustment_item_reason: item.stock_adjustment_item_reason
                })));

                var lotData = originRows.filter((item, index) => {
                    return (
                        originRows.findIndex((item2, index2) => {
                            return typeof item.lot_stock_adjustment_item_lot_seq !== 'undefined' && item.lot_stock_adjustment_item_lot_seq === item2.lot_stock_adjustment_item_lot_seq && item.lot_stock_adjustment_item_id === item2.stock_adjustment_item_id;
                        }) === index
                    );
                });
                    
                lotData = lotData.sort(function(a, b) { 
                    return a.lot_stock_adjustment_item_lotno < b.lot_stock_adjustment_item_lotno ? -1 : a.lot_stock_adjustment_item_lotno > b.lot_stock_adjustment_item_lotno ? 1 : 0;
                });

                setLotRows(lotData.map((item, index) => ({
                    id: item.lot_stock_adjustment_item_lot_seq,
                    lot_no: item.lot_stock_adjustment_item_lotno,
                    lot_stock_adjustment_item_lot_type_name: item.lot_stock_adjustment_item_lot_type_name,
                    lot_stock_adjustment_item_name: item.lot_stock_adjustment_item_name,
                    lot_stock_adjustment_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_stock_adjustment_item_spec, item.lot_stock_adjustment_item_width, item.lot_stock_adjustment_item_depth, item.lot_stock_adjustment_item_height),
                    lot_stock_adjustment_save_workplace_name: item.lot_stock_adjustment_save_workplace_name,
                    lot_stock_adjustment_save_warehouse_name: item.lot_stock_adjustment_save_warehouse_name,
                    lot_stock_adjustment_save_section_name: item.lot_stock_adjustment_save_section_name
                })));
                
                var fileData = originRows.filter((item, index) => {
                    return (
                    originRows.findIndex((item2, index2) => {
                        return typeof item.stock_adjustment_file_id !== 'undefined' && item.stock_adjustment_file_id === item2.stock_adjustment_file_id;
                    }) === index
                    );
                });
            
                fileData = fileData.sort(function(a, b) { 
                    return a.stock_adjustment_file_id < b.stock_adjustment_file_id ? -1 : a.stock_adjustment_file_id > b.stock_adjustment_file_id ? 1 : 0;
                });
            
                setFileRows(fileData.map((item, index) => ({
                    id: item.stock_adjustment_file_id,
                    file_name_sever: item.stock_adjustment_file_name_sever,
                    file_size: item.stock_adjustment_file_size,
                    file_type: item.stock_adjustment_file_type,
                    file_extension: item.stock_adjustment_file_extension,
                    file_name: item.stock_adjustment_file_name,
                    file_type_name: item.stock_adjustment_file_type_name,
                    file_size_dp: item.stock_adjustment_file_size_dp,
                    reg_user_name: item.stock_adjustment_file_user_name,
                    reg_datetime: Moment(item.stock_adjustment_file_user_datetime).format('YYYY-MM-DD HH:mm:ss')
                })));
            }
        }
    }, [originRows]);

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/StockAdjustment/List',
            {
                params: {
                    stock_adjustment_id: params.stock_adjustment_id
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            setOriginRows(response.data);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            setTimeout(() => appStore.setLoading(false), 300);
        });
    };

    const fileDownloadClick = (object) => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
                    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

        if (isIOS) {
            // iOS는 XHR+blob 대신, 폼 POST로 새 탭 열어 서버가 직접 다운로드 처리
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/api/SaveCommon/FileDownload';
            form.target = '_blank'; // 새 탭 (팝업 차단 회피용: 클릭 안에서 즉시 submit)

            const add = (n, v) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = n;
                input.value = v ?? '';
                form.appendChild(input);
            };
            add('fileName', object.row.file_name);
            add('fileNameSever', object.row.file_name_sever);
            document.body.appendChild(form);
            form.submit();
            form.remove();
            return;
        }

        // 나머지(PC/안드): 기존 axios + blob
        axios.post(
            '/api/SaveCommon/FileDownload',
            new URLSearchParams({
                fileName: object.row.file_name,
                fileNameSever: object.row.file_name_sever
            }),
            { withCredentials: true, responseType: 'blob' }
        ).then((res) => {
            if (res.status !== 200) return appStore.capture();
            const type = res.headers?.['content-type'] || 'application/octet-stream';
            const blob = new Blob([res.data], { type });
            const url  = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = object.row.file_name || 'download.bin';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        }).catch((e) => {
            appStore.capture();
            console.log('다운로드 실패', e);
        });
    };

    const handleList = () => {
        navigate("/m/stock_adjustment", { state: { fromSearch } });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleList}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white", 
                                borderColor: "black", 
                                backgroundColor: "black",
                                ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                            }}
                            variant="outlined">
                            목록
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents">
                <div style={{ overflow: 'hidden' }}>
                    {/* 재고조정 기본 정보 */}
                    {data ? (
                        <>
                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>재고조정 정보</h2>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>재고조정번호</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.stock_adjustment_number || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>재고조정유형</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.stock_adjustment_type_name || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>재고조정일자</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.stock_adjustment_date || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>재고조정승인자</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.stock_adjustment_approval_user_name || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>재고조정사유</div>
                            <div 
                                style={{ 
                                fontSize: '16px', 
                                color: '#333', 
                                marginTop: '4px',
                                whiteSpace: 'pre-wrap', // 줄바꿈 유지
                                lineHeight: '1.5'       // 가독성 좋게 줄 간격 추가
                                }}
                            >
                                {(data.stock_adjustment_reason && data.stock_adjustment_reason.trim() !== '') 
                                ? data.stock_adjustment_reason 
                                : '-'}
                            </div>
                            </div>
                        </div>
                        
                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>재고조정 품목</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={itemRows}
                                    columns={itemColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        
                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>재고조정 Lot</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={lotRows}
                                    columns={lotColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>재고조정 파일</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={fileRows}
                                    columns={fileColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, file_name_sever: false, file_size: false, file_type : false, file_extension: false, download: false}}
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        </>
                    ) : (
                        <p style={{ textAlign: "center", color: "#999" }}>재고조정 데이터를 불러오는 중입니다...</p>
                    )}
                    </div>

            </div>
        </div>
    );
};

export default MOB_StockAdjustmentDetail;